import { Guests as DefaultGuests } from '@/features/guest'

function Guests() {
  return (
    <main className="flex flex-col pr-5 pb-6 max-h-full">
      <DefaultGuests />
    </main>
  )
}

export default Guests
